import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import { getHomeUrl } from '../../features/auth/lib/homeUrl.js'
import { posthogCapture } from '../../lib/logging/posthog.js'

/**
 * Redirects to the theme/role-aware home (marketplace) URL. Renders inside
 * ProtectedLayout, so auth is already guaranteed.
 *
 * Used for both the root route and the catch-all; the catch-all passes
 * notFound so broken links and dead bookmarks show up in PostHog instead of
 * being silently erased by the redirect.
 */
export function HomeRedirect({ notFound = false }) {
  const location = useLocation()

  // Empty deps: capture the URL as first seen — the redirect replaces it
  // immediately, so a re-run would log the destination instead
  useEffect(() => {
    if (notFound) {
      posthogCapture('route_not_found', {
        path: `${location.pathname}${location.search}`,
      })
    }
  }, [])

  return <Navigate to={getHomeUrl()} replace />
}

HomeRedirect.propTypes = {
  notFound: PropTypes.bool,
}
